import { $createParagraphNode, ElementNode } from "lexical";

import type { ParagraphNode, SerializedElementNode } from "lexical";

/**
 * Quotes were once registered in the email editor, and reached designs through pasted HTML, but
 * nothing renders one: the email body has no quote, and loading one headless threw. A design saved
 * with a quote therefore loads it as a paragraph holding the same children, and the paragraph is
 * what is saved back. This node is never created; it only claims the `quote` type so it can be
 * read.
 */
export class LegacyQuoteNode extends ElementNode {
  static getType(): string {
    return "quote";
  }

  static clone(node: LegacyQuoteNode): LegacyQuoteNode {
    return new this(node.__key);
  }

  static importJSON(serializedNode: SerializedElementNode): ParagraphNode {
    return $createParagraphNode().updateFromJSON(serializedNode);
  }
}
